import {
  adventureIslandTheme,
  aquaticaTheme,
  buschGardensTheme,
  discoveryCoveTheme,
  seaworldTheme,
  sesamePlaceTheme,
  waterCountryTheme,
} from '@/styles/vanilla/brands.css';
import { Brand } from '@/types';

import { exhaustiveGuard } from './exhaustiveGuard';

export const getTheme = (brand: Brand) => {
  switch (brand) {
    case Brand.AdventureIsland:
      return adventureIslandTheme;

    case Brand.Aquatica:
      return aquaticaTheme;

    case Brand.BuschGardens:
      return buschGardensTheme;

    case Brand.DiscoveryCove:
      return discoveryCoveTheme;

    case Brand.SeaWorld:
      return seaworldTheme;

    case Brand.SesamePlace:
      return sesamePlaceTheme;

    case Brand.WaterCountry:
      return waterCountryTheme;

    default:
      return exhaustiveGuard(brand);
  }
};
